/** The page is used as our uptime monitor. We check the status of this page every minute
 * See https://my.pingdom.com/app/newchecks/checks for more details
 */
import { Box, Typography } from '@mui/material'

const UpTimePage = () => {
  return (
    <Box>
      <Typography>App is up</Typography>
    </Box>
  )
}

export default UpTimePage
